// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  SfxCueRow,
} from "./types";


export default __t.row({
  worldId: __t.u64().name("world_id"),
  partyId: __t.u64().name("party_id"),
  encounterId: __t.u64().name("encounter_id"),
  pulseIndex: __t.u32().name("pulse_index"),
  catalogue: __t.u32(),
  get cues() {
    return __t.array(SfxCueRow);
  },
});
